/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Intake_Height_HintInputs */

const en_us2_body_assessment_intake_height_hint = /** @type {(inputs: Body_Assessment_Intake_Height_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cm, without shoes.`)
};

const pt_br2_body_assessment_intake_height_hint = /** @type {(inputs: Body_Assessment_Intake_Height_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em cm, sem sapato.`)
};

const es_419_body_assessment_intake_height_hint = /** @type {(inputs: Body_Assessment_Intake_Height_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cm, sin zapatos.`)
};

const pt_pt2_body_assessment_intake_height_hint = /** @type {(inputs: Body_Assessment_Intake_Height_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em cm, sem sapatos.`)
};

const fr_fr2_body_assessment_intake_height_hint = /** @type {(inputs: Body_Assessment_Intake_Height_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cm, sans chaussures.`)
};

const de_de2_body_assessment_intake_height_hint = /** @type {(inputs: Body_Assessment_Intake_Height_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cm, ohne Schuhe.`)
};

const it_it2_body_assessment_intake_height_hint = /** @type {(inputs: Body_Assessment_Intake_Height_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In cm, senza scarpe.`)
};

/**
* | output |
* | --- |
* | "In cm, without shoes." |
*
* @param {Body_Assessment_Intake_Height_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_intake_height_hint = /** @type {((inputs?: Body_Assessment_Intake_Height_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Intake_Height_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_intake_height_hint(inputs)
	if (locale === "es-419") return es_419_body_assessment_intake_height_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_intake_height_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_intake_height_hint(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_intake_height_hint(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_intake_height_hint(inputs)
	return en_us2_body_assessment_intake_height_hint(inputs)
});
export { body_assessment_intake_height_hint as "body-assessment.intake_height_hint" }